import { createFileRoute } from '@tanstack/react-router'
import ChatSettings from '@/pages/settings/chat'

export const Route = createFileRoute(
  '/(protected)/settings/chat'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ChatSettings />
}
